'use strict';
const _ = require('lodash');
const $ = require('jquery');
const Backbone = require("backbone");
const PubSub = require('../PubSub');
const ViewContestant = require('./contestant');
const ViewAd = require('./ad');
const template = require('../templates/social.ejs');
const slugify = require('slugify');
const { isMobile } = require('../util/is-mobile');
const GA = require('../constants').GOOGLE;
const OMNITURE = require('../constants').OMNITURE;

module.exports = Backbone.View.extend({
    className: 'flex-container',
    events: {
        'click .btn': 'loadVideo',
        'click .social-cta': 'handleSocialCtaClick'
    },
    /**
     *
     */
    initialize: function (options) {
        _.bindAll(this, 'render');

        options = options || {};

        this.cms = options.cms;
        this.appState = this.cms.get('appState');

        this.dimensions = options.dimensions;
        this.user = options.user;
        this.contestantsArray = [];

        this.runnerUpsArray = [];
        this.finalistsArray = [];
        this.hideAnimation = options.hideAnimation || false;

        this.copy = options.copy;
        this.transitionTime = (parseInt(this.cms.get('text').customization.transition_time) || 500);

        this.listenTo(this.copy, 'change:copy', function() {
            this.render();
            this.renderedToDom();
        }.bind(this));
    },
    /**
     *
     */
    render: function () {
        var model = this.model.toJSON();
        model.copy = _.extend(model.copy, this.copy.get('copy'));
        model.window = this.appState;

        this.$el.addClass('social-generic-category');

        this.$el.css({height: '0'});
        this.$el.html(template(model));

        var sortedContestants = this.model.get('voteData');
        sortedContestants.sort((a, b) => parseInt(a.order, 10) - parseInt(b.order, 10));

        _.forEach(sortedContestants, function(value, index) {

            var contestantModel = new Backbone.Model(_.extend({ voteCount: 0 }, value));

            this.contestantsArray.push(new ViewContestant({
                model: contestantModel,
                user: this.user,
                dimensions: this.dimensions,
                person: this.model.get('person'),
                copy: this.copy,
                cms: this.cms,
                professional: this.model.get('professional'),
                social: this.model.get('social'),
                customization: this.cms.get('text').customization,
                category: this.model
            }));

            this.$('.contestants-wrapper').append(this.contestantsArray[index].render().$el);
            this.contestantsArray[index].renderedToDom();
            
        }.bind(this));

        return this;
    },
    /**
     * [renderedToDom description]
     * @return {[type]} [description]
     */
    renderedToDom: function(update) {

      this.$el.parent().css({height: '0px'});

      if(parseInt(this.model.toJSON().person)) {
        this.$el.parent().addClass('circle');
      }

      if(_.checkIfTrue(this.model.get('display_ad')) && !update) {
        this.renderAd();
      }

      if(!this.hideAnimation) {
        this.scrollAnimation();
      } else {
        this.$el.parent().css({height: 'auto'});
        this.$el.css({height: 'auto'});
      }
    },
    /**
     * [renderAd description]
     * @return {[type]} [description]
     */
     renderAd: function () {

      if(this.adView instanceof ViewAd) return;

      this.adView = new ViewAd({
          categoryIndex: this.model.get('id'),
          adTag: this.model.get('ad_tag') || this.model.get('displayName'),
          model: this.model.get('ad')
      });

      var contestantEls = this.$el.find('.contestant');

      if(contestantEls.length > 0) {
        $(contestantEls[contestantEls.length - 1]).after(this.adView.render().$el)
      } else {
        this.$el.append(this.adView.render().$el);
      }

      this.adView.renderedToDom();
    },
    /**
     * [scrollAnimation description]
     * @return {[type]} [description]
     */
    scrollAnimation: function() {
        const categoryButton = document.querySelector('.category-button[data-category-id="' + this.model.get('id') + '"]');
        const buttonTop = categoryButton.offsetTop;
        const mobileMenuHeight = isMobile.any() ?
                        document.getElementById('header').offsetHeight : 
                        document.getElementById('mtv-mobile-menu').offsetHeight;

        const hasSkybox = document.body.classList.contains('skybox-loaded');
        let skyboxHeight = 0;

        if( hasSkybox ) {
            skyboxHeight = isMobile.any() ?
                        document.querySelector('#mobile_skybox_plus_sticky iframe').offsetHeight :
                        document.querySelector('#skybox_leader_plus_sticky iframe').offsetHeight;
        }

        $('html,body').animate({
            scrollTop: buttonTop - mobileMenuHeight - skyboxHeight
        }, {
            duration: 200,
            complete: function() {
                // fixes issue when the function runs twice due to HTML and body attributes
                if(/(auto)/.test(this.$el.parent().attr('style'))) {
                    return false;
                }
    
                this.$el.parent().css({height: 'auto'});
                this.$el.animate({
                    height: '1200px'
                }, this.transitionTime, function() {
                    $(this).css({height: 'auto'});
                })
            }.bind(this)
        });

    },
    /**
     * [remove description]
     * @return {[type]} [description]
     */
    remove: function() {
        // remove the various Contestants views from the contestants array
        _.forEach(this.contestantsArray, function(value, index) { value.remove(); });
        _.forEach(this.runnerUpsArray, function(value, index) { value.remove(); });
        _.forEach(this.finalistsArray, function(value, index) { value.remove(); });

        this.contestantsArray = null;
        this.runnerUpsArray = null;
        this.finalistsArray = null;

        this.voteData = null;

        if(this.adView) {
            this.adView.remove();
            this.adView = null;
        }

        this.stopListening();
        this.off();

        if(this.copy) {
            this.copy.destroy();
            this.copy = null;
        }

        this.model = null;

        this.recentlyVoted = false;
        this.closedTextDisplayed = false;

        if(typeof this.removeClosedText == 'number') { clearTimeout(this.removeClosedText); console.warn('cancel timeout') };

        return Backbone.View.prototype.remove.call(this);
    },
    /**
     * handleSocialCtaClick
     * @param {object} e - event object
     * @return {void}
     */
    handleSocialCtaClick: function( e ) {
        var val = "instagram to vote_" + this.model.get('name');
        var href = e.currentTarget.href;

        var omParams = {
          name: val,
          section: slugify(this.model.get('name')),
          destination: href,
          isSocial: true
        };

        PubSub.trigger( 'linkClick', omParams);
    }
});



// WEBPACK FOOTER //
// ./app/scripts/views/social.js